<template>
	<wrapper-features-templates-one-column
	:nonAuthenticatedFeature="nonAuthenticatedRoute"
	:customBreadcrumbs="customBreadcrumbs"
	:customHeaderTabs="customHeaderTabs"
	:fullWhiteBox="getMobileAppState"
	@customTabClicked="tabClickHandler"
	@backOrCloseClicked="emit('backOrCloseClicked')">
		<!-- *********************************************
		*												 *
		*                      Content                   *
		*												 *
		********************************************** -->
		<transition name="common-enter-animation" mode="out-in" appear>
			<div class="transition-helper-element" :key="selectedTabComponent">
				<!-- Component Wrapper -->
				<component :is="selectedTabComponent"/>
			</div>
		</transition>
	</wrapper-features-templates-one-column>
</template>

<script setup>
import WrapperFeaturesTemplatesOneColumn from '@/components/wrappers/featuresTemplates/OneColumn'
/* Vue */
import { ref, computed, defineAsyncComponent } from 'vue'
import { useRoute } from 'vue-router'
/* Helpers */
import { nonAuthenticatedRoutes } from '@/router/helpers/validations'

/* Store & mapGetters */
import { mapGetters } from '@/store/helpers/mappers'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['backOrCloseClicked'])

const { getMobileAppState } = mapGetters()
/* Data */
const currentRoute = useRoute()

/* Controls if current route is non authenticated */
const nonAuthenticatedRoute = computed(() => {
	return nonAuthenticatedRoutes().has(currentRoute.path)
})
/*************************************************
*               Custom Breadcrumbs Logic         *
*************************************************/
const customBreadcrumbs = computed(() => {
	return nonAuthenticatedRoute.value ? { currentArea: t('contacts.customBreadcrumbsCurrentArea') } : null
})
/*************************************************
*                    Tabs Logic                  *
*************************************************/
const customHeaderTabs = ref([
	{
		id: 'Bai',
		label: t('contacts.tabs.bai'),
		selected: true
	},
	{
		id: 'Emis',
		label: t('contacts.tabs.emis'),
		selected: false
	},
	{
		id: 'Visa',
		label: t('contacts.tabs.visa'),
		selected: false
	}
])

const tabClickHandler = (event) => {
	customHeaderTabs.value.forEach(tab => {
		tab.selected = tab.id === event
	})
}

const selectedTabComponent = computed(() => {
	const template = customHeaderTabs.value.find(obj => obj.selected).id
	return defineAsyncComponent(() => import('@/components/features/contacts/' + template))
})
</script>

<style lang="scss" scoped>
.transition-helper-element {
	@include commonEnteringAnimation;
	width: 100%;
}
</style>
